import {
  createApiRef,
  FetchApi,
  DiscoveryApi,
  IdentityApi,
} from '@backstage/core-plugin-api';

import { JiraProjects } from './types';

export const jiraApiRef = createApiRef<JiraIssuesApi>({
  id: 'jira-integration-backend',
});

export interface JiraIssuesApi {
  fetchIssues(): Promise<any>;
  fetchProjects(): Promise<JiraProjects>;
}

export class JiraAPIClient implements JiraIssuesApi {
  private readonly fetchApi: FetchApi;
  private readonly discoveryApi: DiscoveryApi;
  private readonly identityApi: IdentityApi;

  constructor(options: {
    fetchApi: FetchApi;
    discoveryApi: DiscoveryApi;
    identityApi: IdentityApi;
  }) {
    this.fetchApi = options.fetchApi;
    this.discoveryApi = options.discoveryApi;
    this.identityApi = options.identityApi;
  }

  private async getBaseUrl() {
    return await this.discoveryApi.getBaseUrl('jira-integration-backend');
  }

  async fetchIssues(): Promise<any> {
    const baseUrl = await this.getBaseUrl();
    const { token } = await this.identityApi.getCredentials();

    const response = await this.fetchApi.fetch(`${baseUrl}/ownTasks`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    return response.json();
  }

  async fetchProjects(): Promise<JiraProjects> {
    const baseUrl = await this.getBaseUrl();
    const { token } = await this.identityApi.getCredentials();

    const response = await this.fetchApi.fetch(`${baseUrl}/projects`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    const projects = await response.json();
    return projects as JiraProjects;
  }
}
